export default "__VITE_ASSET__O8DeA05V__"